export default __webpack_public_path__ + "static/media/Thief's Leggings of Engulfing Twilight.7f26e893.jpg";